"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DOMAIN = exports.ADDITIONAL_META_TYPE = exports.NOTIFICATION_TYPE = exports.IDENTITY_TYPE = exports.SOURCE_TYPES = exports.CHAIN_ID_TO_SOURCE = void 0;
exports.CHAIN_ID_TO_SOURCE = {
    1: 'ETH_MAINNET',
    5: 'ETH_TEST_GOERLI',
    137: 'POLYGON_MAINNET',
    80001: 'POLYGON_TEST_MUMBAI',
    56: 'BSC_MAINNET',
    97: 'BSC_TESTNET',
    10: 'OPTIMISM_MAINNET',
    420: 'OPTIMISM_TESTNET',
    1442: 'POLYGON_ZK_EVM_TESTNET',
    1101: 'POLYGON_ZK_EVM_MAINNET',
};
exports.SOURCE_TYPES = {
    ETH_MAINNET: 'ETH_MAINNET',
    ETH_TEST_GOERLI: 'ETH_TEST_GOERLI',
    POLYGON_MAINNET: 'POLYGON_MAINNET',
    POLYGON_TEST_MUMBAI: 'POLYGON_TEST_MUMBAI',
    BSC_MAINNET: 'BSC_MAINNET',
    BSC_TESTNET: 'BSC_TESTNET',
    OPTIMISM_MAINNET: 'OPTIMISM_MAINNET',
    OPTIMISM_TESTNET: 'OPTIMISM_TESTNET',
    POLYGON_ZK_EVM_TESTNET: 'POLYGON_ZK_EVM_TESTNET',
    POLYGON_ZK_EVM_MAINNET: 'POLYGON_ZK_EVM_MAINNET',
    THE_GRAPH: 'THE_GRAPH',
    PUSH_VIDEO: 'PUSH_VIDEO',
};
var IDENTITY_TYPE;
(function (IDENTITY_TYPE) {
    IDENTITY_TYPE[IDENTITY_TYPE["MINIMAL"] = 0] = "MINIMAL";
    IDENTITY_TYPE[IDENTITY_TYPE["IPFS"] = 1] = "IPFS";
    IDENTITY_TYPE[IDENTITY_TYPE["DIRECT_PAYLOAD"] = 2] = "DIRECT_PAYLOAD";
    IDENTITY_TYPE[IDENTITY_TYPE["SUBGRAPH"] = 3] = "SUBGRAPH";
})(IDENTITY_TYPE = exports.IDENTITY_TYPE || (exports.IDENTITY_TYPE = {}));
var NOTIFICATION_TYPE;
(function (NOTIFICATION_TYPE) {
    NOTIFICATION_TYPE[NOTIFICATION_TYPE["BROADCAST"] = 1] = "BROADCAST";
    NOTIFICATION_TYPE[NOTIFICATION_TYPE["TARGETTED"] = 3] = "TARGETTED";
    NOTIFICATION_TYPE[NOTIFICATION_TYPE["SUBSET"] = 4] = "SUBSET";
})(NOTIFICATION_TYPE = exports.NOTIFICATION_TYPE || (exports.NOTIFICATION_TYPE = {}));
var ADDITIONAL_META_TYPE;
(function (ADDITIONAL_META_TYPE) {
    ADDITIONAL_META_TYPE[ADDITIONAL_META_TYPE["CUSTOM"] = 0] = "CUSTOM";
    ADDITIONAL_META_TYPE[ADDITIONAL_META_TYPE["PUSH_VIDEO"] = 1] = "PUSH_VIDEO";
})(ADDITIONAL_META_TYPE = exports.ADDITIONAL_META_TYPE || (exports.ADDITIONAL_META_TYPE = {}));
exports.DEFAULT_DOMAIN = 'push.org';
//# sourceMappingURL=constants.js.map